export default {
  state: {
    name: '',
    phone: '',
    carType: '',
    carSize: '',
    parkinglot: '',
    startDate: '',
    city: '',
    county: '',
    privacy: '',
    thirdParty: ''
  },
  mutations: {
    setData(state, { name , phone , carType , carSize , parkinglot , startDate , city , county , privacy , thirdParty}) {
      state.name = name;
      state.phone = phone;
      state.carType = carType;
      state.carSize = carSize;
      state.parkinglot = parkinglot;
      state.startDate = startDate;
      state.city = city;
      state.county = county;
      state.privacy = privacy;
      state.thirdParty = thirdParty;
		}
  },
  actions: {},
  getters: {}
};